export default __webpack_public_path__ + "static/media/atm-bottle.9e1cd963.png";